import { css } from '@emotion/react';
import { i18next } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

const defaultLabel = {
  primary: i18next.t('Add', { ns: 'schedule' }),
  cancel: i18next.t('Cancel', { ns: 'schedule' }),
};

type Props = {
  cancelButtonLabel?: string;
  primaryButtonLabel?: string;
  primaryButtonTrackingId?: string;
  cancelButtonTrackingId?: string;
  onCancel?: () => void;
  onAction?: () => void;
};

export const DefaultViewFooter = ({
  cancelButtonLabel = defaultLabel.cancel,
  primaryButtonLabel = defaultLabel.primary,
  primaryButtonTrackingId,
  cancelButtonTrackingId,
  onCancel,
  onAction,
}: Props) => {
  if (!onAction) return null;

  return (
    <footer css={footerStyles}>
      {onCancel && (
        <Button variant='secondary' onClick={onCancel} trackingId={cancelButtonTrackingId}>
          {cancelButtonLabel}
        </Button>
      )}
      <Button
        iconName='plus'
        variant='tertiary'
        trackingId={primaryButtonTrackingId}
        css={{ svg: { flexShrink: 0 } }}
        onClick={onAction}
      >
        {primaryButtonLabel}
      </Button>
    </footer>
  );
};

const footerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2, 2, 2),
  button: { flex: 1 },
});
